import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledFaqIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 12,
			fill: "#D5F0F7"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 10.5,
			fill: "white",
			stroke: "#1F3B44",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.6562 19.8444C21.0815 20.197 20.7419 20.6035 20.5893 21.186C20.4741 21.6262 20.1263 22 19.6713 22C19.2114 22 18.8297 21.6236 18.8863 21.1673C19.0336 19.9812 19.5063 19.4417 20.2343 18.9893C20.8359 18.6115 21.2982 18.1342 21.2982 17.4382C21.2982 16.6576 20.6867 16.1505 19.9261 16.1505C19.4699 16.1505 19.0242 16.34 18.7563 16.73C18.4861 17.1232 18.1291 17.5326 17.6521 17.5326C17.1492 17.5326 16.7279 17.1086 16.8791 16.6289C17.2864 15.3364 18.4994 14.679 19.936 14.679C21.8352 14.679 23.1427 15.7329 23.1427 17.4133C23.1427 18.5518 22.571 19.2976 21.6562 19.8444Z",
			fill: "#1F3B44"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.8011 24.0156C20.7961 24.6221 20.294 25.1094 19.7073 25.1094C19.1008 25.1094 18.6086 24.6221 18.6136 24.0156C18.6086 23.419 19.1008 22.9318 19.7073 22.9318C20.294 22.9318 20.7961 23.419 20.8011 24.0156Z",
			fill: "#1F3B44"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledFaqIcon);
const Memo = memo(ForwardRef);
export default Memo;
